import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/atlas';
export function Testimonials() {
  return <section className="border-y-4 border-ice bg-white px-4 py-6 sm:py-8" data-id="element-172" data-mp="3kqw4ckozx2g4">
      <div className="mx-auto max-w-4xl" data-id="element-173" data-mp="3fyvxe8aid9a1">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-3xl" data-id="element-174" data-mp="3fxku09kz63jg">
          What dental students are saying
        </h2>

        <div className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-175" data-mp="36yplgqugkhcz">
          {testimonials.map((t, i) => <figure key={t.author} className={`flex flex-col rounded-lg border border-navy/10 bg-warm p-4 shadow-sm ${i === 0 ? 'sm:col-span-2' : ''}`} data-id="element-176" data-mp="31zd2ih6pjufo" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-177" data-mp="2s2rtlkrkhz6k">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-teal text-teal" aria-hidden="true" data-id="element-178" data-mp="v7c7r9s8zbqz" data-mpi={s} />)}
              </div>
              <blockquote className="mt-2 text-sm font-medium italic leading-snug text-navy sm:text-base" data-id="element-179" data-mp="h8avb55eobn0">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-2.5 pt-3" data-id="element-180" data-mp="79bntpwdmm1l">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-ice font-display text-lg text-navy" data-id="element-181" data-mp="c7wofqfjj7qk">
                  {t.author.charAt(0)}
                </span>
                <span className="leading-tight" data-id="element-182" data-mp="14uhfeps3thtl">
                  <span className="block text-sm font-extrabold text-navy" data-id="element-183" data-mp="14xde4gbs0aj3">{t.author}</span>
                  <span className="block text-[11px] font-semibold uppercase tracking-wide text-slate2" data-id="element-184" data-mp="q4jwopcy1kbs">
                    {t.role} — {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}